import { render, staticRenderFns } from "./EtapaRevisao.vue?vue&type=template&id=7dabac3a&scoped=true"
import script from "./EtapaRevisao.vue?vue&type=script&lang=js"
export * from "./EtapaRevisao.vue?vue&type=script&lang=js"
import style0 from "./EtapaRevisao.vue?vue&type=style&index=0&id=7dabac3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dabac3a",
  null
  
)

export default component.exports